import { useState, useCallback } from "react";

export interface AppSettings {
  translatorServiceUrl: string;
  summaryServiceUrl: string;
  userServiceUrl: string;
}

export function useSettings() {
  const [settings, setSettings] = useState<AppSettings>(() => {
    const envTranslator = import.meta.env?.VITE_TRANSLATOR_SERVICE_URL || process.env.BUN_PUBLIC_TRANSLATOR_SERVICE_URL || "http://localhost:3001";
    const envSummary = import.meta.env?.VITE_SUMMARY_SERVICE_URL || process.env.BUN_PUBLIC_SUMMARY_SERVICE_URL || "http://localhost:3002";
    const envUser = import.meta.env?.VITE_USER_SERVICE_URL || process.env.BUN_PUBLIC_USER_SERVICE_URL || "http://localhost:3003";

    return {
      translatorServiceUrl: localStorage.getItem("translator_service_url") || envTranslator,
      summaryServiceUrl: localStorage.getItem("summary_service_url") || envSummary,
      userServiceUrl: localStorage.getItem("user_service_url") || envUser,
    };
  });

  const saveSettings = useCallback((newSettings: AppSettings) => {
    setSettings(newSettings);
    localStorage.setItem("translator_service_url", newSettings.translatorServiceUrl);
    localStorage.setItem("summary_service_url", newSettings.summaryServiceUrl);
    localStorage.setItem("user_service_url", newSettings.userServiceUrl);
  }, []);

  return { settings, saveSettings };
}
